export function randomIp() {
  return `${Math.floor(10 + Math.random() * 240)}.${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}`;
}

export function randomAvatar(name) {
  const displayName = name || randomFullName();
  return `https://ui-avatars.com/api/?background=0f4c81&color=fff&name=${encodeURIComponent(displayName)}&size=32&rounded=true`;
}

export function randomPhone() {
  return `+7${Math.floor(9000000000 + Math.random() * 1000000000)}`;
}

export function randomFullName() {
  const names = ["Алексей Смирнов", "Мария Козлова", "Дмитрий Иванов", "Елена Морозова", "Олег Новиков", "Анна Ветрова", "Виктор Логинов"];
  return names[Math.floor(Math.random() * names.length)];
}